import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {message} from '@common/i18n/message';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';
import { DatatableDataQueryKey } from '@common/datatable/requests/paginated-resources';
import { FileItem } from '@app_modules/loan-applications/step1/file-item';

interface Response extends BackendResponse {}

interface Payload {
  id: number|string;
  loan_program_type: string;
}

export function useRemoveAnalyzeItemRateSheet(id: number|string, loan_program_type: string) {
  return useMutation({
    mutationFn: ({id, loan_program_type}: Payload) =>
      removeAnalyzeItemRateSheet({id: id, loan_program_type: loan_program_type}),
      onSuccess: (response: any, payload) => {
      if (response.message) {
        toast(
          message(response.message),
        );
      } else {
        toast(
          message(`You has just removed loan program type ${loan_program_type}.`),
        );
      }
      
      // queryClient.invalidateQueries({queryKey: DatatableDataQueryKey(`market-rates/${id}`)});
    },
    onError: err => showHttpErrorToast(err),
  });
}

function removeAnalyzeItemRateSheet({
  id, loan_program_type
}: Payload): Promise<Response> {
  return apiClient
    .post(`market-rates/${id}/remove-analyze-item`, {loan_program_type: loan_program_type})
    .then(r => r.data);
}

